export const teamLookupFieldDropdown =  [
	{
	  title: "Name",
	  value: "greeting"
	},
	{
	  title: "Email",
	  value: "emailAddress"
	}
]



// WEBPACK FOOTER //
// ./src/pages/teamMembers/filter/teamLookupFields.js